import { Component, h, Prop, Element, Host } from '@stencil/core';

@Component({
  tag: 'qumra-skeleton',
  styleUrl: 'qumra-skeleton.css',
  shadow: true,
})
export class QumraSkeleton {
  @Prop() loading: boolean = true;
  @Element() el!: HTMLElement;

  render() {
    return (
      <Host class="h-full w-full">
     <div class={this.loading ? 'skeleton hf' : ''}>
        <slot></slot>
      </div>
      </Host>
    );
  }
}

